!((document, Drupal) => {
  "use strict";

  Drupal.behaviors.sidebar = {
    attach: function (context) {
      const exposedForms = document.querySelectorAll(".views-exposed-form");
      if (exposedForms) {
        exposedForms.forEach((form, index) => {
          const reset = form.querySelector(".form-actions input[data-drupal-selector='edit-reset']");
          const selects = form.querySelectorAll("select");

          if (selects.length > 0) {
            selects.forEach((select) => {
              select.addEventListener("change", function(event) {
                if (reset !== null) {
                  if (event.target.value == 'All') {
                    reset.classList.remove('is-shown');
                  } else {
                    reset.classList.add('is-shown');
                  }
                }
              });
            });
          }
        });
      }
    },
  };
})(document, Drupal);
